module.exports = __webpack_public_path__ + "static/media/Kirby Mayfield Headshot_1591105912204.4522665e.png";